import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://hduhhdjzjcnhxvedbsxi.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhkdWhoZGp6amNuaHh2ZWRic3hpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA1NzI1OTgsImV4cCI6MjA5NjE0ODU5OH0.xCOPQGg9wuEDD461rrpnRvsuUK6qDL90HJ1L6ApI7D4'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})